module.exports = __webpack_public_path__ + "static/img/navq.5135ce3.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/navq.png
// module id = mMgi
// module chunks = 0